<template>
    <el-dialog
        :title="`${this.isUpdate ? 'Edit' : 'Create'} an event`"
        :visible.sync="showModal"
        width="70%"
        @close="closeModal"
        append-to-body
    >
        <el-form
            :model="event"
            :rules="rules"
            ref="eventForm"
            label-width="80px"
        >
            <el-form-item label="Name" prop="name">
                <el-input v-model="event.name"></el-input>
            </el-form-item>
            <ns-loader
                ref="universesLoader"
                :toLoad="toLoad"
                @dataFetched="onDataFetched"
            >
                <ns-loader-spinner slot="loader"></ns-loader-spinner>
                <div slot="content">
                    <el-form-item label="Universe" prop="universe">
                        <el-select v-model="event.universe_uid" placeholder="Select a universe">
                            <el-option
                                v-for="universe in universes"
                                :key="universe.uid"
                                :label="universe.display_name"
                                :value="universe.uid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </ns-loader>
            <el-form-item v-if="userHasMultipleEntities" label="Entity">
                <el-select v-model="entityScopeValue" placeholder="Select an entity">
                    <el-option
                        v-for="entity in userEntities"
                        :key="entity.uid"
                        :label="entity.display_name"
                        :value="entity.uid">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="closeModal">Cancel</el-button>
            <el-button type="primary" @click="validate">Validate</el-button>
        </span>
    </el-dialog>
</template>

<script>

import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import NsLoaderSpinner from '../../partials/ns-loader-template.vue';
import {mapGetters} from 'vuex';

export default {
    components: {
        NsLoader,
        NsLoaderSpinner
    },
    props: {

    },

    data: function(){
        return {
            showModal: false,
            event:{
                name: '',
                universe_uid: ''
            },
            entityScopeValue: '',
            isUpdate: false,
            universes: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Please input a name for the event',
                        trigger: 'blur'
                    }
                ],
                universe_uid: [
                    {
                        required: true,
                        message: 'Please select a universe',
                        trigger: 'blur'
                    }
                ],
            }
        };
    },

    computed: {
        ...mapGetters([
            'userHasMultipleEntities',
            'userEntities'
        ]),
        toLoad() {
            return [
                {
                    name: 'universes',
                    model: 'universes'
                }
            ];
        }
    },
    methods: {
        onDataFetched(data) {
            if(this.entityScopeValue){
                this.universes = data.universes.filter(universe => {
                    return this.entityScopeValue == universe.scopes.entity_uid;
                })
            }
            else{
                this.universes = data.universes;
            }
        },
        open(event) {
            this.isUpdate = false;
            if (event) {
                this.event = event;
                this.isUpdate = true;
                this.entityScopeValue = event.scopes.entity_uid;
            }
            this.showModal = true;
        },
        reset() {
            this.event = {
                name: '',
                universe_uid: ''
            };
            this.closeModal();
        },
        closeModal() {
            this.showModal = false;
        },
        validate() {
            this.$refs.eventForm.validate(valid => {
                if (valid) {
                    if (this.isUpdate) {
                        this.$store.dispatch('updateItem', {
                            item: this.event,
                            model: 'events',
                        }).then(() => {
                            this.$notify.success({message: 'Event was successfully updated'});
                            this.reset();
                        }).catch(() => {
                            this.$notify.error({message: 'Event couldn\'t be updated'});
                        });
                    } else {
                        this.$store.dispatch('createItem', {
                            item: this.event,
                            model: 'events',
                            url: this.$store.state.api.meta.listModels.events.url,
                            // TODO: see if universe / entity selector values need to be dependant of selected entity / universe
                            scopes: {'X-Entity-Uid': this.userHasMultipleEntities ? this.entityScopeValue : this.userEntities[0].uid}
                        }).then(() => {
                            this.$notify.success({message: 'Event was successfully created'});
                            this.reset();
                        }).catch(() => {
                            this.$notify.error({message: 'Event couldn\'t be created'});
                        });
                    }
                }
            });
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Events/eventModal.vue